import React from 'react';

import './App.css';
import '@ionic/react/css/core.css';

import { IonApp, IonRouterOutlet, IonSplitPane } from '@ionic/react';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import { Route } from 'react-router-dom';
import { IonReactRouter } from '@ionic/react-router';

import HomePage from './pages/Home';
import DetailsProduct from './pages/Details';
import ContactPage from './pages/Contact';

function App() {
  return (
  <IonApp>
    <IonReactRouter>
      <IonSplitPane contentId="main">
        <IonRouterOutlet id={'main'}>
          <Route path="/" exact component={HomePage} />
          <Route path="/:id/:title" exact component={HomePage} />
          <Route path="/:id/:title/products/" exact component={HomePage} />
          <Route path="/:id/:title/contact/" exact component={ContactPage} />
          <Route path="/about" exact component={DetailsProduct} />
          <Route path="/:id/:title/product/:product/:product_title" exact component={DetailsProduct} />
        </IonRouterOutlet>
      </IonSplitPane>
    </IonReactRouter>
  </IonApp>
  );
}

export default App;
